import { ButtonLink } from "../components/ui/Button";
import { useDocumentMeta } from "../lib/meta";
import { PageIntro } from "../components/ui/PageIntro";

export const NotFoundPage = () => {
  useDocumentMeta({
    title: "Page not found",
    description: "The requested page could not be found on The Education Project website.",
  });

  return (
    <div className="flex flex-col bg-white">
      {/* Full-bleed Photo Hero Banner */}
      <PageIntro
        eyebrow="404"
        title="The page you requested could not be found."
        summary="The link may be outdated or the address may have been entered incorrectly."
      />

      {/* Section 1: Navigation Actions - White Background */}
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-2xl px-6 flex flex-col items-center justify-center text-center">
          <div className="flex flex-col gap-3 sm:flex-row justify-center w-full max-w-md">
            <ButtonLink to="/" variant="primary" className="uppercase tracking-wider text-sm !px-6">Return home</ButtonLink>
            <ButtonLink to="/contact" variant="lime" className="uppercase tracking-wider text-sm !px-6">
              Contact the organization
            </ButtonLink>
          </div>
        </div>
      </section>
    </div>
  );
};
